<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2024-07-24 15:01:09
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2024-07-29 15:44:46
 * @FilePath: /epec-purchase-shopping-mall/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/nesting/toPayFeedbackList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="docker-server">
    <!-- <iframe
      id="iframeChild"
      ref="iframeDom"
      name="iframeChild"
      :src="getPageUrl"
      frameborder="0"
      scrolling="auto"
    ></iframe> -->
    <iframe
      id="iframeChild"
      ref="iframeDom"
      name="iframeChild"
      :src="getPageUrl"
      frameborder="0"
      scrolling="auto"
      sandbox="allow-same-origin allow-top-navigation allow-forms allow-scripts allow-downloads allow-popups"
    ></iframe>
  </div>
</template>

<script>
import request from '../../api/nesting';

export default {
  data() {
    return {
      getPageUrl: '',
    };
  },
  mounted() {
    request
      .getGsnPageUrlInfo({
        gsnParam: 'toPayFeedback',
      })
      .then((res) => {
        if (res.status) {
          this.getPageUrl = res.data.gsnReturnUrl;
        }
      });
  },
};
</script>

<style lang="scss" scoped>
/** iframe样式 */
#iframeChild {
  width: 100%;
  height: calc(100vh - 125px);
}
</style>
